/* src/app/navigation-sidebar-footer/navigation-sidebar-footer.component.css */
.inviso-text-black {
  color: #463f3d;
}
.build-version {
  margin-left: -8px;
  font-size: 70%;
}
/*# sourceMappingURL=navigation-sidebar-footer.component.css.map */
